import React from 'react';
import {
    Container,
    Grid,
    Typography,
    makeStyles
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import CreditLogTable from './CreditLogTable';

const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export default function CreditLogView() {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Page
            className={classes.root}
            title={t('navbar.creditlog')}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('navbar.creditlog')}
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <CreditLogTable/>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}